import { render, staticRenderFns } from "./AuctionDetailsTable.vue?vue&type=template&id=392020b6&scoped=true&"
import script from "./AuctionDetailsTable.vue?vue&type=script&lang=js&"
export * from "./AuctionDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuctionDetailsTable.vue?vue&type=style&index=0&id=392020b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392020b6",
  null
  
)

export default component.exports